import React, { Component } from 'react';
import BedrijvenSearch from './../../Global/Modules/BedrijvenSearch'

class Bedrijven extends Component {

  render() {
    return (
      <div className="route">
        <h1 className="pageTitle">
          Bedrijven zoeken
          </h1>
        <BedrijvenSearch />
      </div>
    );
  }
}

export default Bedrijven;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Bedrijven.js